export const VK_API_VERSION = 5.103;

export const KEY_CODE_ESC = 27;
export const KEY_CODE_LEFT_ARROW = 37;
export const KEY_CODE_RIGHT_ARROW = 39;
